<template>
  <!-- <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg> -->
  <i :class="iconName"></i>
</template>

<script>
export default {
  name: 'svg-icon',
  props: {
    iconClass: {
      type: String
    },
    className: {
      type: String
    }
  },
  computed: {
    iconName() {
      if(this.iconClass){
         return `el-icon-${this.iconClass}`
      }else  if (this.className) {
        return 'svg-icon ' + this.className
      } 
       return 'svg-icon'
     
    }
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1.2em;
  height: 1.2em;
  vertical-align: -0.18em;
  fill: currentColor;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue